import { Button } from '../../../atoms/Button';
import { TextArea } from '../../../atoms/Textarea';
import { useForm } from 'react-hook-form';

interface IInputDiv {
  onSubmit: (text: string) => void;
  text?: string;
}

export default function InputDiv({ onSubmit, text }: IInputDiv) {
  const {
    register,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<{
    comment: string;
  }>();

  const submit = (data: { comment: string }) => {
    reset();
    onSubmit(data.comment);
  };

  const comment = watch('comment') || '';

  return (
    <form onSubmit={handleSubmit(submit)}>
      <div className='flex flex-col items-end gap-md'>
        <TextArea
          placeholder='Escreva um comentário'
          rows={5}
          {...register('comment')}
          errorMessage={errors.comment && 'Digite um comentário'}
          defaultValue={text || ''}
        />
        <Button
          size='regular'
          disabled={comment.length <= 3}
          className='w-full text-center items-center justify-center md:w-fit'
        >
          {text ? 'Atualizar comentário' : 'Postar comentário'}
        </Button>
      </div>
    </form>
  );
}
